/** Normalize backend errors (FastAPI Pydantic validation returns arrays). */
export function formatApiError(detail, fallback = "Something went wrong") {
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => {
        const field = Array.isArray(e?.loc) ? e.loc.slice(1).join(".") : "";
        return field ? `${field}: ${e.msg}` : e.msg || JSON.stringify(e);
      })
      .join(" • ");
  }
  if (typeof detail === "object") return JSON.stringify(detail);
  return String(detail);
}
